// modal.js

import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

export const CloseButtonStyled = styled.button`
  position: fixed;
  z-index:2;
  top: 10px;
  right: 10px;
  width: 50px;
  height:50px;
  border: none;
  background-color:white;
  &:hover{
    background-color: #EEEEEE;
  }
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 15px #3f486599;  
`;

export const CloseButton = styled.i`
  width:100%;
  height:100%;
  background-position: 50%;
  background-repeat: no-repeat;
  display:inline-block;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='32' height='32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M26.304 23.8819L27 24.5779L25.5778 26L16.5 16.9222L7.42219 26L6 24.5779L6.69597 23.8819C6.69597 23.8819 6.69597 23.8718 6.70606 23.8617L11.5072 19.0706L15.0778 15.5001L6 6.42223L6.69597 5.7262C6.69597 5.7262 6.69597 5.71609 6.70606 5.706C6.71614 5.69592 6.71614 5.70599 6.72623 5.69591L7.42219 5L8.11815 5.69591C8.11815 5.69591 8.12824 5.69592 8.13833 5.706L16.5 14.0677L24.8617 5.706C24.8617 5.706 24.8718 5.70599 24.8818 5.69591L25.5778 5L26.2738 5.69591C26.2738 5.69591 26.2839 5.69592 26.294 5.706C26.294 5.706 26.294 5.71611 26.304 5.7262L27 6.42223L17.9222 15.5001L21.5735 19.1514L26.294 23.8617C26.294 23.8617 26.294 23.8718 26.304 23.8819V23.8819Z' fill='%23999999'/%3E%3C/svg%3E");
  background-size: 35px;
  cursor: pointer;
`;

const ModalOverlay = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #031037DE;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display:flex;
  justify-content:center;
  > div {
  width: 100%;
  height:100%;
  }
`;



const Modal = ({ onClose, children }) => {
  return ReactDOM.createPortal(
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        {children}
        <CloseButtonStyled onClick={onClose} aria-label="Close Modal">
          <CloseButton></CloseButton>
        </CloseButtonStyled>
      </ModalContent>
    </ModalOverlay>,
    document.body
  );
};

export default Modal;
